module.exports = __webpack_public_path__ + "img/Frame_s25_b0_9x9_1_C0C_UK.10e37129.png";